import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 400,
  name: 'Bad Request',
  description:
    'The server cannot process the request because of a client-side error. The request has malformed syntax, invalid parameters, or is otherwise unreadable by the server.',
  causes: [
    'Malformed JSON or XML in the request body — missing commas, unclosed brackets, or invalid encoding.',
    'Invalid or missing required query parameters, headers, or form fields that the server expects.',
    'URL contains invalid characters, is too long, or has a malformed query string.',
  ],
  fixes: [
    'Inspect the request in browser dev tools (Network tab). Check the request body, headers, and URL for formatting errors.',
    'Validate your JSON payload with a linter before sending. Ensure Content-Type matches the body format (application/json for JSON, etc.).',
    'Read the response body — most APIs include a detailed error message explaining which field or parameter is invalid.',
  ],
  monitoringTip:
    'If your endpoint starts returning 400 errors to valid requests, it often means a deployment broke input parsing. Uptrack detects the status code change and alerts you before users file bug reports.',
}

export const Route = createFileRoute('/_site/http/400')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
